export type { IColor } from 'react-color-palette';
export { ColorService, useColor } from 'react-color-palette';

export * from './ColorPalettePicker';
